import React from 'react';

const GeneralContentBlock = ({ data, title }) => {
  return (
    <>
      {data && Object.keys(data).length ? <div className="whiteCard">
        <h2>{title}</h2>
        {Object.keys(data).map((key, index) => {
          return (
            <div key={index} className="generalContentBlockBody">
              <strong>{key}</strong> : {data[key]}
            </div>
          )
        })}
      </div> : null}
    </>
  )
}

export default GeneralContentBlock;
